import * as classNames from 'classnames';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import AccessibleDiv from 'components/AccessibleDiv/AccessibleDiv';
import artboardLayoutContainerStyles from 'components/ArtboardLayoutContainer/styles.module.scss';
import BalanceLine from 'components/BalanceLine';
import carouselItemSlideActionsStyles from 'components/CarouselItemSlideActions/styles.module.scss';
import createDndScrollZone from 'components/DndScrollZone';
import ZoomWrapper from 'components/ZoomWrapper';
import { ProjectsConfig, TOOLBAR_ELEMENT_ID } from 'const';
import { setFrozenEntityIdAction } from 'containers/FrozenAction/actions';
import { useProjectType } from 'hooks/useProjectType';
import { createMediumVerticalStrength } from 'utils/dndScrollZone';
import { IMainProps } from './models';
import styles from './styles.module.scss';

const DnDScrollZone = createDndScrollZone<React.HTMLAttributes<HTMLElement>>('section');

const Main: React.FunctionComponent<IMainProps> = (props) => {
  const dispatch = useDispatch();

  const {
    artboardBackground,
    artboardHeight,
    showScreensPanel,
    assetPanel,
    content,
    screensPanel,
    showPreview,
    scale,
  } = props;
  const projectType = useProjectType();
  const { areScreensResizable } = ProjectsConfig[projectType];

  const handleClickOutsideFrozenAction = (event: React.MouseEvent<HTMLDivElement>): void => {
    const target = event.target as HTMLElement;
    const slideAction = target.closest(`.${carouselItemSlideActionsStyles.SlideActions}`);
    if (slideAction) {

      return;
    }
    const artboardLayoutContainer = target.closest(`.${artboardLayoutContainerStyles.ArtboardLayoutContainer}`);
    if (artboardLayoutContainer) {

      return;
    }
    dispatch(setFrozenEntityIdAction(null));

  };

  return (
    <div className={styles.Main}>
      <aside className={styles.screensPanel}> {screensPanel} </aside>
      <DnDScrollZone
        className={styles.content}
        style={{ background: artboardBackground }}
        verticalStrength={createMediumVerticalStrength}
      >
        <AccessibleDiv
          onClick={handleClickOutsideFrozenAction}
          className={classNames(styles.content__wrapper, {
            [styles.content__wrapper_hiddenScreensPanel]: !showScreensPanel,
          })}
        >
          <ZoomWrapper wrapContent={!showPreview}>
            {content}
          </ZoomWrapper>
          <BalanceLine top={areScreensResizable ? artboardHeight : undefined} scale={scale} />
        </AccessibleDiv>
      </DnDScrollZone>
      <aside className={styles.assetPanel}> {assetPanel} </aside>
      <div className={styles.toolbar} id={TOOLBAR_ELEMENT_ID} />
    </div >
  );
};

export default Main;
